import React, { useEffect } from "react";
import CreateQuestion from "./CreateQuestion";

import { useDispatch, useSelector } from "react-redux";
import TestsRequests from "services/tests";
import GridContainer from "@jumbo/components/GridContainer";
import { Grid } from "@material-ui/core";

const AllQuestions = ({ id }) => {
  const { allQuestions } = useSelector(({ tests }) => tests);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(TestsRequests.getAllQuestions(id));
  }, []);

  return (
    <GridContainer>
      <Grid item xs={12}>
        <CreateQuestion quizId={id} />
        {/* <QuestionElement quizId={id} /> */}
        {allQuestions &&
          allQuestions.map((item) => (
            <CreateQuestion question={item} key={item._id} />
          ))}
      </Grid>
    </GridContainer>
  );
};

export default AllQuestions;
